;(function() {
  'use strict'

  angular.module('app.survey').component('surveyQuestionRating', {
    controller: Controller,
    templateUrl: 'survey-question-rating.html',
    bindings: {
      survey: '<',
      question: '<',
    },
  })

  /* @ngInject */
  function Controller() {
    var ctrl = this

    ctrl.isSolid = isSolid

    function isSolid(choice) {
      var selected = ctrl.question.selected[0]

      // If nothing is selected then no options are solid
      if (!selected) {
        return false
      }

      return selected.numericOption >= choice.numericOption
    }
  }
})()
